module.exports = {
  App: {},
  Login: {
    username: "Username",
    usernamePlaceholder: "type username",
    password: "Password",
    passwordPlaceholder: "type password",
    passwordTip: "Length at six to eight chars",
    role: "Role",
    rolePlaceholder: "type role",
    login: "Login",
    reset: "Reset",

    student: "Student",
    teacher: "Teacher",
    teacherHeader: "Class Adviser",
    schoolAdmin: "Teacher Managers",
    systemAdmin: "System Administrator",
  },
  Home: {
    systemName: "STUDENTS ACADEMIC PERFORMANCE EARLY WARNING MANAGEMENT SYSTEM",
    editPassword: "Edit Password",
    logout: "Logout",
    tip: "Tip",
    ifLogout: "If to logout?",
  },
  MenuNames: {
    home: "Home",

    academicPerformance: "Academic Performance",

    academicWarning: "Academic Warning",
    warningSettings: "Warning Settings",
    warningQuery: "Warning Query",
    academicAssistance: "Academic Assistance",

    studentProfile: "Student Profile",

    statisticAnalysis: "Statistic Analysis",
    studentPerformanceAnalysis: "Student Performance Analysis",
    academicWarningInformation: "Academic Warning Information",
    academicWarningAnalysis: "Academic Warning Analysis",

    userManagement: "User Management",
    student: "Student",
    teacherClassAdviser: "Teacher/Class Adviser",
    teachingManagers: "Teaching Managers",
    systemAdministrator: "System Administrator",
  },
  TitleInfo: {
    basicInformationOfStudents: "Basic information of students",
  },
  TableInfo: {
    major: "major",
    majorPlaceholder: "Please select a major",
    grade: "grade",
    grade2: "grade",
    gradePlaceholder: "Please select a grade",
    className: "class",
    classNamePlaceholder: "Please select a class",
    courseName: "course name",
    classAdviser: "Class Adviser",
    department: "department",
    courseType: "course Type",
    courseCredit: "course credit",
    courseTeacher: "Course Teacher",
    none: "none",

    studentNumber: "student number",
    studentName: "student name",
    MethodOfAchievingGrades: " Method of achieving grades",
    usualGrade: "Usual grade",
    finaGrade: "Final grade",
    skillScore: "Skill score",
    totalMark: "Total Mark",
    resit: "Retake",
    initialRepair: "Initial Attempt",
    exemption: "Make-up Course",

    rebuild: "Re-enrollment",

    pass: "pass",
    medium: 'medium',
    good: 'good',
    qualified: "qualified",
    excellent: "excellent",

    flunk: "flunk",
    belowStandard: "below standard",

    index: "index",
    operate: "operate",
    assistanceSuggestions: "Assistance Suggestions",
    time: "time",
    analysis: "analysis",
    earlyWarningRules: "Early Warning Rules",
    colorSign: "Color Sign",
    bjrs: "class size",
    cxqbkctgrs: "Passed All Initial Courses",
    bkhqbkctgrs: "All Courses Passed",
    kcbtgrs: "Failed Courses After Retake",

    yjkcfbqk: "Distribution of warning courses",
    yjkcms: "Number of warning courses",
  },
  SearchInfo: {
    term: "term",
    termPlaceholder: "Please select a term",
    number: "number",
    numberPlaceholder: "Please enter student number",
    name: "name",
    namePlaceholder: "Please enter student name",
    namePlaceholder2: "Please enter Teacher/Class Adviser name",
    namePlaceholder3: "Please enter Teaching Managers name",
    namePlaceholder4: "Please enter System Administrator name",

    jobNumber: "job number",
    jobNumberPlaceholder: "Please enter job number",
    position: "position",
    positionPlaceholder: "Please select a position",
    department: "department",
    departmentPlaceholder: "Please select a department",
    sex: "sex",
    sexPlaceholder: "Please select a sex",
    man: "Male",
    women: "Female",
    earlyWarningLevel: "Early warning level",
    earlyWarningLevelPlaceholder: "Please select a early warning level",
    blueAlert: "blue alert",
    yellowAlert: "yellow alert",
    orangeAlert: "orange alert",
    redAlert: "red alert",
    detail: "detail",
    blueAlertNumber: "Blue Alerts",
    yellowAlertNumber: "Yellow Alerts",
    orangeAlertNumber: "Orange Alerts",
    redAlertNumber: "Red Alerts",
  },
  BtnText: {
    cancel: "Cancel",
    confirm: "Confirm",
    query: "query",
    reset: "reset",
    create: "create",
    delete: "delete",
    update: "modify",
    submit: "submit",
    save: "Save",
  },
  Tips: {
    pleaseSelectDeletedTeacher: "Please select the teacher that needs to be deleted first",
    deletedTeacherTips: "This operation will delete the teacher. Do you want to continue?",
    pleaseSelectDeletedUser: "Please select the user that needs to be deleted first",
    deletedUserTips: "This operation will delete the user. Do you want to continue?",
    pleaseSelectDeletedStu: "Please select the student that needs to be deleted first",
    deletedStuTips: "This operation will delete the student. Do you want to continue?",
    pleaseSelectDeletedTeachingAdministrator: "Please select the teaching administrator that needs to be deleted first",
    deletedTeachingAdministratorTips: "This operation will delete the teaching administrator. Do you want to continue?",
    qtxbfjy: "Please provide assistance suggestions",
  },
  EchartInfo: {
    ksqk: "Exam situation",
    btgkcqk: "Failure to pass the course",
    door: "subject",
    bkqk: "Supplementary examination situation",
    bktgkes: "Number of courses passed in make-up exams",
    bkwtgkcs: "Number of courses that failed the make-up exam",
    cxqk: "Initial repair situation",
    cxtgkcs: "Number of courses passed in the initial course",
    cxwtgkcs: "Number of courses that did not pass the initial course",
    courseCount: "Course<br/> Count",
    gradingMethod: "Grading Method",
    courseType: "course type",
  },
  DiaInfo: {
    warningDetails: "Warning details",
    stuFailedCoursesInfo: "This student (%name) has failed a total of %number courses",
    earlyRule1: "Accumulated $num unqualified courses (below 60 points)",
    earlyRule2: "Accumulated $num-$num unqualified courses (below 60 points)",
    earlyRule3: "Accumulated $num or more courses that are not qualified (less than 60 points)",
    dijixueqi: "The %num semester of %year",
    dijixueqi2: "first",
    dijixueqi3: "second",
    yjrsqk: "Number of warning personnel",
    peopleInTotal: "{b} {c} ({d}%) people in total",
    loginAgain: 'Login Failed.Please login to our system again.',
  },
};



// WEBPACK FOOTER //
// ./src/lang/en.js